<template>
    <div class="viewOffset">
        <p class="fs-4">{{ manageStore.lang("StatsView.color_usage.title") }}</p>
        <div id="plotMaterials"></div>
        <p class="fs-4">{{ manageStore.lang("StatsView.ticket_history.title") }}</p>
        <div id="plotMaterialHistory"></div>
    </div>
</template>

<script setup>
import { useManageStore } from '@/stores/manage';
import { useStatsStore } from '@/stores/stats';
import { useTicketsStore } from '@/stores/tickets';
import Plotly from 'plotly.js/dist/plotly'
import { onMounted } from 'vue';

const ticketStore = useTicketsStore();
const statsStore = useStatsStore()
const manageStore = useManageStore();

onMounted(() => {
    initializeChartData();
});

async function initializeChartData() {
    let colorsUsed;
    try {
        colorsUsed = await statsStore.getColorsUsed();
    }
    catch (e) {
        console.log("No colors");
        colorsUsed = [];
    }

    const printingMaterials = [];
    printingMaterials.length = 0;
    for (const color of ticketStore.colors) {
        printingMaterials.push(color.name);
    }

    var traceMats = {
        x: printingMaterials,
        y: colorsUsed,
        type: 'bar',
        textposition: 'auto',
        hoverinfo: 'auto',
        marker: {
            color: printingMaterials,
            opacity: 0.6,
            line: {
                color: 'rgb(8,48,107)',
                width: 1.5
            }
        }
    };
    var dataMats = [traceMats];

    var layoutMats = {
        barmode: 'stack',
        yaxis: {
            tickmode: 'linear',
            tick0: 0,
            dtick: 1,
        }
    };
    Plotly.newPlot('plotMaterials', dataMats, layoutMats);


    let colorsUsage;
    try {
        colorsUsage = await statsStore.getColorsOverTime();
    } catch (e) {
        console.log("No colors over time");
        colorsUsage = {};
    }

    const dataHistory = [];

    for (const colorKey in colorsUsage) {
        const colorFunc = colorsUsage[colorKey];

        let displayColor = colorKey;

        if(colorKey === "any")
        {
            displayColor = "grey";
        }
        else if(colorKey === "white")
        {
            displayColor = "lightgrey";
        }
        
        const trace = {
            x: colorFunc.x,
            y: colorFunc.y,
            type: 'bar',
            name: colorKey,
            marker: {
                color: displayColor,
                line: {
                    color: displayColor,
                    width: 1.5
                }
            },
            text: colorFunc.y,
            textposition: 'auto',
            textfont: {
                size: 12,
                color: 'black'
            }
        };
        
        dataHistory.push(trace);
    }

    const layoutHistory = {
        barmode: 'group',
        xaxis: {
            title: 'Months of the Year'
        },
        yaxis: {
            title: 'Amount of Tickets'
        }
    };

    Plotly.newPlot('plotMaterialHistory', dataHistory, layoutHistory);
}
</script>

<style scoped>
.viewOffset {
    margin-top: 130px;
}
</style>